import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { Currency } from 'app/models/currency.model';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {
  DisplayedGroup,
  DisplayedProduct, MenuSection,
  OverridePositionsMap,
  Product,
} from 'app/models/menu.model';
import { MenuOverrideService } from "app/services/menu-override.service";
import { UntilDestroy } from "@ngneat/until-destroy";
import { TranslateService } from "@ngx-translate/core";
import { SnackbarService } from "app/services/snackbar.service";
import { MenuService } from 'app/services/menu.service';
import { PipeConfiguration } from 'app/models/pipe.model';
import { Organization } from 'app/models/organization.model';

@UntilDestroy()
@Component({
  selector: 'app-menu-section-products[menuPipes][menuSection][currentOrganization][editProduct]',
  templateUrl: './section-products.component.html',
  styleUrls: ['./section-products.component.scss']
})
export class SectionProductsComponent implements OnChanges {
  @Input() menuSection: MenuSection;
  @Input() currentOrganization: Organization;
  @Input() group: DisplayedGroup;
  @Input() overridePositionsMap: OverridePositionsMap;
  @Input() productsMap: Map<string, DisplayedProduct>;
  @Input() originalProductsMap: Map<string, Product>;
  @Input() currency: Currency | null;
  @Input() searchQuery: string;
  @Input() menuPipes: PipeConfiguration[];
  // Показывать ли в списке блюд warning "не будет отображаться на киоске".
  // Родитель (menu-main-content) уже учитывает и текущую группу (должна быть родителем),
  // и тип сборки (везде кроме production).
  @Input() showKioskWarning: boolean = false;

  @Output() editProduct = new EventEmitter<Product>();
  products: DisplayedProduct[] = [];

  constructor(
    private translate: TranslateService,
    private snackbar: SnackbarService,
    private menuService: MenuService)
  {
  }

  ngOnChanges() {
    this.products = [];
    for (const productInGroup of this.group.groupStructure.productsInGroup) {
      if (this.productsMap.has(productInGroup.externalProductId)) {
        const product = this.productsMap.get(productInGroup.externalProductId);
        this.products.push(product);
      }
    }
  }

  onOpenEditDialogProduct($event: Product) {
    this.editProduct.emit($event);
  }

  async dropProduct($event: CdkDragDrop<Product>) {
    if (this.searchQuery){
      const message = this.translate.instant('MENU.WARNING.PROHIBITION_ON_ORDERING')
      this.snackbar.info(message);
      return;
    }
    if ($event.previousIndex !== $event.currentIndex) {
      moveItemInArray(this.products, $event.previousIndex, $event.currentIndex);
      const overridesGroupPosition = MenuOverrideService.changeProductOrders(this.group, this.products, this.overridePositionsMap, this.menuSection.id);
      await this.menuService.saveOverridePositions(this.menuSection.id,[overridesGroupPosition], [this.menuSection.id]);
    }
  }

  getOriginalProduct(product: Product): Product {
    return this.originalProductsMap.get(product.externalId);
  }
}
